const baseUrl = "https://api.valianttinfo.com/valiantinfo_app/";

// const baseUrl = "http://15.206.70.176:3201/valiantinfo_app/";

//const baseUrl = "http://13.233.232.180:3201/valiantinfo_app/";

export { baseUrl };
